<script>
import { format as formatNumber } from '@/utils/number';

export default {
  name: 'ChartSelector',
  props: {
    charts: {
      type: Array,
      default: () => [],
    },
    activeChart: {
      type: Object,
      default: () => ({}),
    },
    icon: {
      type: String,
      default: '',
    },
  },
  methods: {
    formatNumber,
    handleSelect(chart) {
      this.$emit('change', chart);
    },
  },
};
</script>

<template>
  <ElDropdown
    type="outlined"
    trigger="click"
    placement="bottom-start"
    @command="handleSelect"
  >
    <div class="chart-selector">
      <div class="chart-selector__inner">
        <img :src="icon" width="40" alt="" />

        <span class="chart-selector__info">
          {{ activeChart?.name || '...' }}
        </span>

        <strong v-show="activeChart?.overall">
          {{ formatNumber(activeChart?.overall) }}
        </strong>
      </div>

      <div class="chart-selector__arrow">
        <i class="el-icon-arrow-down" />
      </div>
    </div>

    <ElDropdownMenu slot="dropdown">
      <ElDropdownItem
        v-for="chart in charts"
        :key="chart.name"
        :command="chart"
      >
        {{ chart.name }} {{ chart.overall }}
      </ElDropdownItem>
    </ElDropdownMenu>
  </ElDropdown>
</template>

<style lang="scss">
.chart-selector {
  border: 1px solid #d1d4dd;
  border-radius: 16px;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  height: rem-calc(60px);

  &__inner {
    padding: 1rem;
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  &__arrow {
    padding: 1rem 1.5rem;
    border-right: 1px solid #d1d4dd;
  }

  i {
    vertical-align: middle;
  }

  .el-button {
    height: 60px;
  }
}
</style>
